import { render, staticRenderFns } from "./Managerment.vue?vue&type=template&id=697687fd&scoped=true"
import script from "./Managerment.vue?vue&type=script&lang=ts"
export * from "./Managerment.vue?vue&type=script&lang=ts"
import style0 from "./Managerment.vue?vue&type=style&index=0&id=697687fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697687fd",
  null
  
)

export default component.exports